/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Msg_Doc_PendingInputs */

const en_msg_doc_pending = /** @type {(inputs: Msg_Doc_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Document uploaded, pending admin review.`)
};

const es_msg_doc_pending = /** @type {(inputs: Msg_Doc_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Documento subido, pendiente de revisión administrativa.`)
};

const fr_msg_doc_pending = /** @type {(inputs: Msg_Doc_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Document téléchargé, en attente de l'examen de l'administrateur.`)
};

const de_msg_doc_pending = /** @type {(inputs: Msg_Doc_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dokument hochgeladen, wartet auf Administratorprüfung.`)
};

const id_msg_doc_pending = /** @type {(inputs: Msg_Doc_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dokumen diunggah — menunggu peninjauan admin.`)
};

/** @type {(inputs: Msg_Doc_PendingInputs) => LocalizedString} */
const ja_msg_doc_pending = en_msg_doc_pending;

/** @type {(inputs: Msg_Doc_PendingInputs) => LocalizedString} */
const zh_msg_doc_pending = en_msg_doc_pending;

/** @type {(inputs: Msg_Doc_PendingInputs) => LocalizedString} */
const ar_msg_doc_pending = en_msg_doc_pending;

/** @type {(inputs: Msg_Doc_PendingInputs) => LocalizedString} */
const it_msg_doc_pending = en_msg_doc_pending;

/** @type {(inputs: Msg_Doc_PendingInputs) => LocalizedString} */
const ru_msg_doc_pending = en_msg_doc_pending;

/** @type {(inputs: Msg_Doc_PendingInputs) => LocalizedString} */
const pt_msg_doc_pending = en_msg_doc_pending;

/** @type {(inputs: Msg_Doc_PendingInputs) => LocalizedString} */
const ko_msg_doc_pending = en_msg_doc_pending;

/**
* | output |
* | --- |
* | "Document uploaded, pending admin review." |
*
* @param {Msg_Doc_PendingInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const msg_doc_pending = /** @type {((inputs?: Msg_Doc_PendingInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Msg_Doc_PendingInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_msg_doc_pending(inputs)
	if (locale === "es") return es_msg_doc_pending(inputs)
	if (locale === "fr") return fr_msg_doc_pending(inputs)
	if (locale === "de") return de_msg_doc_pending(inputs)
	if (locale === "ja") return ja_msg_doc_pending(inputs)
	if (locale === "zh") return zh_msg_doc_pending(inputs)
	if (locale === "ar") return ar_msg_doc_pending(inputs)
	if (locale === "id") return id_msg_doc_pending(inputs)
	if (locale === "it") return it_msg_doc_pending(inputs)
	if (locale === "ru") return ru_msg_doc_pending(inputs)
	if (locale === "pt") return pt_msg_doc_pending(inputs)
	return ko_msg_doc_pending(inputs)
});